import { ReactNode } from "react";
import { Link } from "wouter";
import { DOMAIN, FONT, PRODUCT_NAME, SAGE, WARM } from "@shared/brand";

interface Props {
  children: ReactNode;
}

export function LegalPageLayout({ children }: Props) {
  return (
    <div className="min-h-screen bg-[#FAF7F1]">
      {/* Simple top bar — brand mark and back nav */}
      <header className="border-b border-[#E8DFCC] bg-white/50">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link href="/" className="font-serif text-lg" style={{ fontFamily: FONT.serif, color: WARM.ink }}>
            {PRODUCT_NAME}
          </Link>
          <Link
            href="/"
            className="text-sm underline"
            style={{ fontFamily: FONT.sans, color: SAGE[600] }}
          >
            Back to home
          </Link>
        </div>
      </header>

      {/* Rendered markdown */}
      <main className="max-w-3xl mx-auto px-6 py-12">
        <article
          className="prose prose-neutral max-w-none
                     prose-headings:font-serif
                     prose-h1:text-4xl prose-h1:mb-6
                     prose-h2:text-2xl prose-h2:mt-10 prose-h2:mb-4
                     prose-h3:text-xl prose-h3:mt-6 prose-h3:mb-2
                     prose-p:text-[#2B2A26] prose-p:leading-relaxed
                     prose-a:text-[#4F6B51] prose-a:underline
                     prose-table:text-sm
                     prose-th:bg-[#F0E8D4] prose-th:p-2
                     prose-td:p-2 prose-td:border prose-td:border-[#E8DFCC]"
          style={{ fontFamily: FONT.sans }}
        >
          {children}
        </article>
      </main>

      <footer className="border-t border-[#E8DFCC] mt-16">
        <div className="max-w-3xl mx-auto px-6 py-6 text-sm text-[#65635C]">
          <div className="flex flex-wrap gap-4" style={{ fontFamily: FONT.sans }}>
            <Link href="/privacy-policy" className="hover:underline">Privacy Policy</Link>
            <Link href="/terms-of-service" className="hover:underline">Terms of Service</Link>
            <a href={`mailto:support@${DOMAIN.primary}`} className="hover:underline">Contact</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
